<template>
  <div class="monthly">
    <div ref="head">
      <div class="tap-bar">
        <div :class="['tap', tap !== 0 || 'pitchOn']" @click="cutTap(0)"><span>总汇总</span></div>
        <div :class="['tap', tap !== 1 || 'pitchOn']" @click="$router.push('/monthly-detail?date1=' + date1)">
          <span>分月明细</span></div>
        <div :class="['tap', tap !== 2 || 'pitchOn']" @click="cutTap(2)"><span>分类汇总</span></div>
      </div>
    </div>
    <div class="seek">
      <div class="date-box" @click="show = true">
        <van-icon name="clock-o"/>
        <span class="time">{{date1}}</span>
      </div>
      <p v-if="lastest">数据更新至：{{lastest}}</p>
      <p>单位：千元</p>
    </div>
    <div class="content" ref="tableContent" v-if="tap === 0">
      <virtual-table
        :header="allHeader"
        :data="allData"
        :height="height"
      ></virtual-table>
    </div>

    <div class="sort" v-if="tap === 2">
      <div class="sort-box" v-for="(item, index) of sortList" :key="index">
        <p>{{item.title}}</p>
        <virtual-table
          :header="item.header"
          :data="item.list"
          :max-height="200"
          :scroll-bottom="true"
        ></virtual-table>
      </div>
    </div>

    <van-popup
      v-model="show"
      position="bottom"
      :style="{ height: '280px' }"
    >
      <van-datetime-picker
        v-model="date"
        type="year-month"
        @confirm="confirmOk"
        @cancel="show = false"
        :formatter="formatter"
      />
    </van-popup>
  </div>
</template>

<script>
  import VirtualTable from '../../components/table-scroll'
  import {monthly} from '../../api/v1'
  import {getTimes, upOfDown} from '../../utils'

  export default {
    name: 'monthly',
    data() {
      return {
        tap: 0,
        date: null,
        show: false,
        date1: '',
        list: null,
        allHeader: [],
        allData: [],
        height: 0,
        sortList: [],
        lastest: ''
      }
    },
    created() {
      let qu = this.$route.query
      let date = getTimes('Y-M')
      if (qu.date1) date = qu.date1
      this.date = new Date(date)
      this.date1 = getTimes('Y-M', date)
      if (qu.tap || qu.top === 0) this.tap = parseInt(qu.tap)
      this.cutTap(this.tap)
    },
    methods: {
      getList(type) {
        return new Promise((resolve, reject) => {
          monthly.getMonthlyList({
            total_month: getTimes('YM', this.date1),
            data_type: type
          }).then(res => {
            if (res.code === 200) {
              this.lastest = res.data.lastest
              resolve(res.data)
            }
          }).catch(err => reject(err))
        })
      },
      cutTap(v) {
        this.tap = v
        switch (v) {
          case 0:
            this.getTableContentSize()
            this.getList('总汇总').then(res => {
              this.allData = res.data
              this.allHeader = res.columns.map(item => {
                let obj = {
                  title: item,
                  key: item,
                  align: 'right',
                  width: 60
                }
                if (['类型'].includes(item)) {
                  obj.headerAlign = 'center'
                  obj.align = 'left'
                }
                if (!['类型', '任务指标'].includes(item)) {
                  obj.render = (h, p) => {
                    let text = p.row[item]
                    if (p.row['任务指标'] === 'Ev%') {
                      return h('div', {class: 'td-down-of-up'}, [
                        h('span', text),
                        h('i', {class: upOfDown(text)})
                      ])
                    } else {
                      return h('span', text)
                    }
                  }
                } else {
                  obj.fixed = 'left'
                }
                return obj
              })
            })
            break
          case 2:
            this.getList('分类汇总').then(res => {
              let header = res.columns.map(item => {
                let obj = {
                  title: item,
                  key: item,
                  align: 'right',
                  headerAlign: 'center',
                  width: 80
                }
                if (['同比增长'].includes(item)) {
                  obj.render = (h, p) => {
                    let text = p.row[item]
                    return h('div', {class: 'td-down-of-up'}, [
                      h('span', text),
                      h('i', {class: upOfDown(text)})
                    ])
                  }
                }
                if (['(000 RMB)'].includes(item)) {
                  obj.fixed = 'left'
                  obj.align = 'left'
                }
                return obj
              })
              let list = res.data
              list = Object.keys(list).filter(item => item !== 'columns').map(item => {
                return {
                  title: item,
                  header: header || [],
                  list: list[item] || []
                }
              })
              this.sortList = list
            })
            break
        }
      },
      getTableContentSize() {
        this.$nextTick(() => {
          this.height = this.$refs.tableContent.offsetHeight
        })
      },
      formatter(type, value) {
        if (type === 'year') {
          return `${value}年`;
        } else if (type === 'month') {
          return `${value}月`
        }
        return value;
      },
      confirmOk(e) {
        this.date = e
        this.date1 = getTimes('Y-M', e)
        this.show = false
        this.cutTap(this.tap)
      }
    },
    components: {
      VirtualTable
    },
    mounted() {
    },
    computed: {},
    beforeDestroy() {
    }
  }
</script>

<style lang="scss" scoped>
  .monthly {
    overflow: hidden;
    width: 100%;
    height: 100%;

    .tap-bar {
      padding: 10px 10px 0;
      display: flex;

      .tap {
        width: 97px;
        height: 27px;
        background: url('~@/assets/imgs/tap15@2x.png') no-repeat;
        background-size: 100% 100%;
        font-size: 15px;
        color: #fff;
        text-align: center;
        line-height: 27px;
        padding-right: 10px;

        &.pitchOn {
          background: url('~@/assets/imgs/onTap15@2x.png') no-repeat;
          background-size: 100% 100%;
        }
      }
    }

    .sort {
      padding: 10px;

      .sort-box {
        p {
          color: #fff;
          padding: 10px 0;
        }
      }
    }
  }
</style>
